module.exports = __webpack_public_path__ + "img/btn-bg.13e21593.png";